import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { TrialQuestionnaireAlert } from 'entities/Subscription/ui/TrialQuestionnaireAlert'
import { TrialTenLimitConversationsAlert } from 'entities/Subscription/ui/TrialTenLimitConversationsAlert'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AlertAddCredits, AlertAddTrialCredits, AlertMaxSegments } from 'entities/Reminders'
import { RcsNotSupportedFilesAlert } from 'entities/Rcs'
import { useConversationMessagesContext } from 'widgets/ConversationMessages/context'
import { ConversationInboxAlert } from 'widgets/ConversationMessages/ui/ConversationMessageFieldAlerts/ConversationInboxAlert/ConversationInboxAlert'
import { ConversationChatbotAlerts } from './ConversationChatbotAlert'
import { ConversationOptOutAlert } from './ConversationOptOutAlert/ConversationOptOutAlert'
import { ConversationBlockedContactAlert } from './ConversationBlockedContactAlert/ConversationBlockedContactAlert'
import { ConversationCalendlyAlert } from './ConversationCalendlyAlert/ConversationCalendlyAlert'

export const ConversationMessageFieldAlerts = observer(() => {
  const { conversationStore } = useEntitiesContext()
  const store = useConversationMessagesContext()
  const {
    chatbotExecutionStore,
    messageFieldStore: { showRcsNotSupportedFilesAlert, setShowRcsNotSupportedFilesAlert },
  } = store

  const { isOnboardingFlow, init, loading } = store.conversationMessageFieldAccessStore

  useEffect(() => {
    init()
  }, [])

  if (loading) return null

  return (
    <>
      {isOnboardingFlow && store.conversation && (
        <TrialQuestionnaireAlert conversation={store.conversation} />
      )}
      <ConversationInboxAlert />

      {store.enableTrialAlertLimitConversations && (
        <TrialTenLimitConversationsAlert
          totalAmount={conversationStore.itemsLimitTrialCount}
          onCloseTrialAlert={store.setHideTrialAlertNotForOwner}
        />
      )}

      <ConversationOptOutAlert />
      <ConversationBlockedContactAlert />

      <AlertAddCredits />
      <AlertMaxSegments />
      {!isOnboardingFlow && <AlertAddTrialCredits />}

      {store.conversation && (
        <ConversationChatbotAlerts
          store={chatbotExecutionStore}
          conversation={store.conversation}
        />
      )}
      {store.conversation && <ConversationCalendlyAlert conversation={store.conversation} />}
      {!isOnboardingFlow && showRcsNotSupportedFilesAlert && (
        <RcsNotSupportedFilesAlert onClose={() => setShowRcsNotSupportedFilesAlert(false)} />
      )}
    </>
  )
})
